import { AbstractDigitalSignature } from '../../base/interface';
import { ml_dsa87 } from '@noble/post-quantum/ml-dsa.js';

/**
 * Asymmetric signature with the ML-DSA-87 algorithm.
 */
export class MLDSA87DSWorker extends AbstractDigitalSignature {
  /**
   *
   * @returns signature
   */
  public static sign(plain: Uint8Array, secret_key: Uint8Array): Promise<Uint8Array> {
    return new Promise((resolve, reject) => {
      resolve(ml_dsa87.sign(plain, secret_key));
    });
  }

  /**
   *
   * @returns if OK return with the plain text without signature, throw error otherwise
   */
  public static verify(
    signature: Uint8Array,
    public_key: Uint8Array,
    plain: Uint8Array
  ): Promise<Uint8Array> {
    return new Promise((resolve, reject) => {
      const r = ml_dsa87.verify(signature, plain, public_key);
      if (!r) {
        reject('Signature was forged or corrupt');
      } else {
        resolve(plain);
      }
    });
  }

  public static describe(): string {
    return 'MLDSA87-DS';
  }
}
